export default "__VITE_ASSET__BgFQCP18__"